import { useEffect, useMemo, useState } from 'react'
import Swal from 'sweetalert2'
import { BaseComponentWithContextProps, componentWithContext } from '../../../../../base/customHooks/componentHOC'
import IPButton from '../../../../../components/IPButton'
import Table from '../../../../../components/Table'
import IPInput from '../../../../../components/IPInput'
import { PreOrderListModel, PreOrderListModelList } from '../models/models'
import { GetPreOrderListApi } from '../services/getPreOrderListApi'
import { useNavigate } from 'react-router-dom'
import { DeletePreOrderReferenceApi } from '../services/deletePreOrderRefApi'
import { create } from 'domain'
import { CheckPreOrderListAuthApi } from '../services/checkPreOrderListAuthApi'

function PreOrderList(props: BaseComponentWithContextProps) {


  const [list, setList] = useState<PreOrderListModelList[]>([])
  const [auth, setAuth] = useState<boolean>(false)
  const [addDealer, setAddDealer] = useState<any>()
  const [dealerFromText, addDealerText] = useState<string>("")

  useEffect(() => {
    checkAuth()
  }, [])

  useEffect(() => {
    if (auth)
      getList()
  }, [auth])

  const getList = async () => {
    props.showLoading()
    const list: GetPreOrderListApi = new GetPreOrderListApi({})

    list
      .getPreOrderList()
      .then((res: any) => {
        props.hideLoading()
        setList(res)
      })
      .catch(err => {
        Swal.fire({
          icon: 'error',
          title: err.description,
          showConfirmButton: true,
          allowOutsideClick: false,
        })
        props.hideLoading()
      })
  }

  const checkAuth = async () => {
    props.showLoading()
    const list: CheckPreOrderListAuthApi = new CheckPreOrderListAuthApi({})

    list
      .check()
      .then((res: any) => {
        props.hideLoading()
        setAuth(res)
      })
      .catch(err => {
        Swal.fire({
          icon: 'error',
          title: err.description,
          showConfirmButton: true,
          allowOutsideClick: false,
        })
        props.hideLoading()
      })
  }

  const deleteOrderRef = async (ref: string) => {
    Swal.fire({
      icon: 'question',
      title: `${ref} ön siparişini silmek istediğinize emin misiniz?`,
      showConfirmButton: true,
      allowOutsideClick: false,
      showDenyButton: true,
      confirmButtonText: 'Evet',
      denyButtonText: 'Hayır',
    }).then(async result => {
      if (result.isConfirmed) {
        props.showLoading()
        const list: DeletePreOrderReferenceApi = new DeletePreOrderReferenceApi({})
        list
          .deleteOrder(ref)
          .then((res: any) => {
            props.hideLoading()
            Swal.fire({
              icon: 'success',
              title: res,
              showConfirmButton: true,
              allowOutsideClick: false,
            })
            getList()
          })
          .catch(err => {
            Swal.fire({
              icon: 'error',
              title: err.description,
              showConfirmButton: true,
              allowOutsideClick: false,
            })
            props.hideLoading()
          })
      }
    })
  }


  const tableColumns = useMemo(
    () => [
      {
        Header: '#',
        accessor: 'count',
      },
      {
        Header: 'Referans No',
        accessor: 'refNo',
      },
      {
        Header: 'Bayi Kodu',
        accessor: 'dealerCode',
      },
      {
        Header: 'Bayi Adı',
        accessor: 'dealerName',
      },
      {
        Header: 'Firma Adı',
        accessor: 'companyName',
      },
      {
        Header: 'Sipariş Numaraları',
        accessor: 'orderNumber',
      },
      {
        Header: 'Ön Sipariş Tarihi',
        accessor: 'createdDate',
      },
      {
        Header: 'Onay Durumu',
        accessor: 'approval',
      },
      {
        Header: 'İşlemler',
        accessor: 'edit',
      },
    ],
    []
  )

  const navigate: any = useNavigate()

  const tableData = useMemo(
    () =>
      list.map((item, index) => {
        const data = {
          count: index + 1,
          refNo: item.ReferenceNumber,
          dealerCode: item.DealerCode,
          dealerName: item.DealerName,
          companyName: item.CompanyName,
          orderNumber: item.OrderNumber,
          createdDate: new Date(item.CreatedDate).toLocaleDateString('tr-TR') + ' ' + new Date(item.CreatedDate).toLocaleTimeString('tr-TR'),
          edit: (<>
            {!(item.OrderNumber?.length > 0) &&
              <a
                data-action-type='delete'
                role='button'
                style={{ cursor: 'pointer' }}
                data-toggle='tooltip'
                data-original-title={"Sil"}
                onClick={() => deleteOrderRef(item.ReferenceNumber)}
              >
                <i className='icon-trash-2' style={{ fontSize: '1.2rem', color: 'red' }}></i>
              </a>
            }
            <a
              data-action-type='edit'
              role='button'
              style={{ cursor: 'pointer', marginLeft: '20px' }}
              data-toggle='tooltip'
              data-original-title={"Düzenle"}
              onClick={() => navigate(`../admin/HomeAndSiteOperation/EditPreOrder?refNumber=${item.ReferenceNumber}`)}
            >
              <i className='icon-edit' style={{ fontSize: '1.2rem', color: 'green' }}></i>
            </a></>
          ),
          approval: item.DealerApproval === 0 ? (<span className='badge badge-warning'>Onayınız Bekliyor</span>) :
            item.DealerApproval === 1 ? (<span className='badge badge-success'>Bayi Onayı Bekliyor</span>) :
              item.DealerApproval === -1 ? (<span className='badge badge-warning'>Reddedildi</span>) :
                item.DealerApproval === 2 ? (<span className='badge badge-warning'>Onaylandı</span>) :
                  item.DealerApproval === 4 ? (<span className='badge badge-success'>Kısmi Onay</span>) :
                    (<span className='badge badge-warning'>Bilinmiyor</span>)
        }
        return data
      }),
    [list]
  )


  return (
    <div className='container'>
      <div className='content col-lg-12 m-auto'>
        <div className='card'>
          <div className='card-header d-flex justify-content-between'>
            <span className='h4'>Ön Sipariş Listesi</span>
          </div>
          <div className='card-body'>
            {/* <div className='row'>
              <div className='col-lg-6'>
                <IPInput
                  type={'text'}
                  value={dealerFromText}
                  placeholder='Bayi Giriniz'
                  onChange={(e) => {
                    addDealerText(e.target.value)
                  }}
                />
                <label style={{ color: 'red' }}>Virgül ile ayırınız.</label>
              </div>
            </div> */}
            <div className='row'>
              <Table columns={tableColumns} data={tableData} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default componentWithContext(PreOrderList)
